
import Vue from "vue"
import { VueConstructor } from "vue/types/umd"
import WorkerFormInterview from "./WorkerFormInterview.vue"
import WorkerFormUpdateProfile from "@/components/worker/WorkerFormUpdateProfile.vue"
import WorkerFormDocument from "./WorkerFormDocument.vue"
import { state } from '@/plugins/state'
// Import dialog components
import SendCVDialog from "@/components/workers/SendCVDialog.vue"
import SendSMSDialog from "@/components/workers/SendSMSDialog.vue"
import UpdateStateDialog from "@/components/workers/UpdateStateDialog.vue"
import ManagePositionsDialog from "@/components/workers/ManagePositionsDialog.vue"
import ArchiveDialog from "@/components/workers/ArchiveDialog.vue"
import AddCommentDialog from "@/components/workers/AddCommentDialog.vue"
import UpdateAvailabilityDialog from "@/components/workers/UpdateAvailabilityDialog.vue"
import AvailabilityRequestDialog from "@/components/workers/AvailabilityRequestDialog.vue"

export default (Vue as VueConstructor<Vue & InstanceType<typeof WorkerFormInterview> & InstanceType<typeof WorkerFormUpdateProfile>>).extend({
    name: "WorkerTabsComponent",
    components: {
        WorkerFormInterview, 
        WorkerFormUpdateProfile, 
        WorkerFormDocument,
        SendCVDialog,
        SendSMSDialog,
        UpdateStateDialog,
        ManagePositionsDialog,
        ArchiveDialog,
        AddCommentDialog,
        UpdateAvailabilityDialog,
        AvailabilityRequestDialog
    },
    data: () => ({
        tab: 0,
        agency: state.agency, //  /!\ Remove all the agency occurrences when document goes in full prod /!\  \\
        drawer: false,
        showSendCV: false,
        showSendSMS: false,
        showUpdateState: false,
        showManagePositions: false,
        isRemovingPositions: false,
        showArchive: false,
        showAddComment: false,
        showUpdateAvailability: false,
        showAvailabilityRequest: false,
        displayedPanel: 0,
        componentKey: 0,
    }),
    computed: {
        isWorkerDetailRoute(): boolean {
            // Check if we're on the workers/:id route (not update)
            return this.$route.path.match(/^\/workers\/\d+$/) !== null;
        },
        isWorkerUpdateRoute(): boolean {
            // Check if we're on the workers/update/:id route
            return this.$route.path.match(/^\/workers\/update\/\d+$/) !== null;
        },
        shouldShowNavigationButton(): boolean {
            // Show the button only in specific contexts
            if (this.isWorkerDetailRoute) {
                return true; // Always show on workers/:id
            }
            
            // For workers/update/:id, check if we came from workers/:id using the query param
            if (this.isWorkerUpdateRoute && this.$route.query.from === 'detail') {
                return true;
            }
            
            return false; // Don't show in other cases
        },
        buttonText(): string {
            if (this.isWorkerDetailRoute) {
                return this.$vuetify.lang.t('$vuetify.go_to_worker_file');
            } else {
                return this.$vuetify.lang.t('$vuetify.return_to_worker_list');
            }
        },
        buttonMargins(): string {
            // Apply different margins based on the route
            if (this.isWorkerDetailRoute) {
                return 'mb-1 mt-1'; // Different margins for update route
            } else {
                return 'mb-3 mt-3'; // Original margins
            }
        },
        returnRoute(): string {
            // Get the worker ID
            const workerId = this.$route.params.id;
            return `/workers/${workerId}`;
        },
        selectedWorker(): string[] {
            // Return the worker ID as an array for compatibility with dialog components
            return [this.$route.params.id];
        }
    },
    methods: {
        generateActiveProposalDocument(): void {
            this.tab = 2
            setTimeout(() => {
                this.$refs.worker_form_document.generateActiveProposalDocument()
            }, 250)
        },
        handleNavigation(): void {
            if (this.isWorkerDetailRoute) {
                // Navigate to update route with a query param to track the source
                this.$router.push({
                    path: `/workers/update/${this.$route.params.id}`,
                    query: { from: 'detail' }
                });
            } else {
                // Go back to workers/:id
                this.$router.push(this.returnRoute);
            }
        },
        refreshPage(): void {
            // Increment the key to force component re-render
            this.componentKey += 1;
        },
        // Ensure the action panel is open when opening the drawer
        openDrawerWithPanel() {
            this.drawer = !this.drawer;
            this.displayedPanel = 0;
        }
    }
})
